import { render, staticRenderFns } from "./BookingCardPlaceholder.vue?vue&type=template&id=1790ad7d&scoped=true&"
import script from "./BookingCardPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BookingCardPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./BookingCardPlaceholder.vue?vue&type=style&index=0&id=1790ad7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1790ad7d",
  null
  
)

export default component.exports